<script>
import LoginForm from "../../molecules/Login/LoginForm.vue";
import LoginWelcome from "../../molecules/AuthWelcome.vue";
import LoginCandidates from "../../molecules/FoundCandidates.vue";
import LoginCandidateWide from "../../atoms/Login/LoginCandidateWide.vue";
import RecentLogins from "../../molecules/Login/RecentLogins.vue";
import RecentLoginDivider from "../../atoms/Divider.vue";

export default {
    name: "LoginCard",
    components: {RecentLoginDivider, RecentLogins, LoginCandidateWide, LoginCandidates, LoginWelcome, LoginForm},
    props: {
        loginCandidates: {
            type: Array,
            required: false,
        },
        recentLogins: {
            type: Array,
            required: false,
        },
        errors: {
            type: Array,
            required: false
        }
    },
    computed: {
        hasCandidates() {
            return this.loginCandidates && this.loginCandidates.length > 0;
        },
        hasRecentLogins() {
            return this.recentLogins && this.recentLogins.length > 0;
        }
    }
}
</script>

<template>
    <div>
        <div class="card py-5 px-lg-4 d-flex flex-row login-card transparent-card" v-if="!hasCandidates">
            <recent-logins v-on="$listeners" v-if="hasRecentLogins" :candidates="recentLogins"/>
            <login-welcome v-else :title="trans('general.page.login.title')" :description="trans('general.page.login.description')" />
            <div class="form d-flex flex-column justify-content-center w-100 px-xl-5" i>
                <div class="d-flex flex-column gap-2 w-100 px-md-4 px-xl-0">
                    <div class="d-flex justify-content-between mb-4 d-none d-lg-block">
                        <h1>{{ trans('general.page.login.head_title') }}</h1>
                    </div>
                    <div class="d-flex flex-column align-items-center gap-3 mb-5  d-lg-none">
                        <img alt="Logo" class="d-lg-none" src="/img/logo.svg" width="200">
                    </div>

                    <div class="d-lg-none d-flex flex-column gap-3" v-if="hasRecentLogins">
                        <div class="w-auto" v-for="candidate in recentLogins" :key="candidate.id">
                            <login-candidate-wide v-on="$listeners" :candidate="candidate"/>
                        </div>
                    </div>

                    <a href="#loginForm" class="text-decoration-none ">
                        <recent-login-divider :text="trans('general.page.login.use_another_profile')" v-if="hasRecentLogins" class="d-lg-none" />
                    </a>

                    <login-form v-on="$listeners" :errors="errors" id="loginForm"/>
                </div>
            </div>
        </div>
        <div class="card py-5 px-lg-4 d-flex flex-row login-card" v-else>
            <login-candidates v-on="$listeners" :candidates="loginCandidates"/>
        </div>
    </div>
</template>

<style scoped>
@media (max-width: 768px) {
    .transparent-card {
        background-color: transparent;
    }
}
</style>
